const profileData = {
  name: "Your Name",
  headline: "Product-minded Software Engineer",
  bio: "I design and ship accessible, performant web products with a focus on clean UX and measurable business outcomes.",
  experience: [
    {
      role: "Senior Frontend Engineer",
      company: "Example Labs",
      period: "2023 - Present",
      highlights: [
        "Led redesign of customer dashboard used by 120k+ monthly users.",
        "Reduced median page load time by 42% through bundle and image optimization.",
        "Partnered with design and data teams to launch experimentation workflows."
      ]
    },
    {
      role: "Software Engineer",
      company: "Northwind Systems",
      period: "2020 - 2023",
      highlights: [
        "Built internal component library used across 6 product teams.",
        "Implemented CI quality gates that cut production regressions by 30%.",
        "Mentored junior developers and ran onboarding workshops."
      ]
    }
  ],
  projects: [
    {
      name: "SignalBoard",
      description: "Analytics workspace for product and growth teams.",
      tech: ["React", "TypeScript", "Node.js"],
      outcome: "Helped teams reduce reporting turnaround from days to minutes."
    },
    {
      name: "StoryKit",
      description: "Reusable design system and docs platform.",
      tech: ["React", "CSS Modules", "Storybook"],
      outcome: "Improved UI consistency and accelerated feature delivery."
    },
    {
      name: "QueuePilot",
      description: "Operations dashboard for service scheduling.",
      tech: ["React", "Express", "PostgreSQL"],
      outcome: "Enabled automated assignment workflows and improved SLA compliance."
    }
  ],
  skills: [
    "JavaScript",
    "TypeScript",
    "React",
    "Node.js",
    "Design Systems",
    "Accessibility",
    "Performance Optimization",
    "Testing",
    "Product Thinking"
  ],
  contact: {
    email: "your.email@example.com",
    location: "City, Country",
    availability: "Open to full-time and consulting opportunities"
  },
  links: {
    website: "https://your-website.com",
    github: "https://github.com/your-handle",
    linkedin: "https://linkedin.com/in/your-handle",
    resume: "https://your-website.com/resume"
  }
};

export default profileData;
